import React, { Fragment, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { FaSignOutAlt } from "react-icons/fa"

import { logout } from "utils"
import { ConfirmationModal } from "components"
import classes from "./SideNavigationLogout.module.scss"

const SideNavigationLogout = () => {
  const navigate = useNavigate()

  const [t] = useTranslation()

  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

  const handleLogout = () => {
    logout()

    navigate("/")
  }

  return (
    <Fragment>
      <div
        className={classes["menu-item"]}
        onClick={() => setOpenConfirmationModal(true)}
      >
        <span className={classes["title"]}>
          <FaSignOutAlt />
          <span className={classes["text"]}>
            {t("خروج")}
          </span>
        </span>
      </div>

      <ConfirmationModal
        show={openConfirmationModal}
        title={t("آیا_می_خواهید_از_پنل_خارج_شوید")}
        onHide={() => setOpenConfirmationModal(false)}
        onConfirm={handleLogout}
      />
    </Fragment>
  )
}

export default SideNavigationLogout
